import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './component/App/App.jsx';
import reportWebVitals from '../src/reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../src/component/App/App.css';
import './index.scss';
import  MediaStoreProvider from './Context/MediaStore.js';
import  AuthStoreProvider  from './Context/AuthStore.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthStoreProvider>
      <MediaStoreProvider>
        <App />
      </MediaStoreProvider>
    </AuthStoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
